import notificationStreamModule from "../notificationStreamModule";

const signalR = {
    notifications: {
        NotificationStream: "NotificationStream",
            ChatPrivacySettingNotifications: "ChatPrivacySettingNotifications"
    },
    types: {
        NewNotification: 'NewNotification',
            NotificationsRead: 'NotificationsRead',
            NotificationMarkedInteracted: 'NotificationMarkedInteracted',
            NotificationRevoked: 'NotificationRevoked',
            chatEnabled: "ChatEnabled",
            chatDisabled: "ChatDisabled"
    }
}

notificationStreamModule.constant("signalR", signalR);

export default signalR;